export const cards = {
  display: "grid",
  gridAutoRows: "min-content",
  gap: 3,
  gridTemplateColumns: "repeat(auto-fit, minmax(275px, 1fr))",
};

export const empty = {
  textAlign: "center",
  pt: 6,
};
